<template lang="html">
  <div id="floorplans-page">
    <div class="row no-gutters">
      <transition name="fade" mode="out-in">
        <availability
        class="col-lg-5 col-md-6 col-12"
        v-show="(!onComparePage && deviceMd) ||
        (!deviceMd && mobileShowAvailability)"
        />
      </transition>
      <transition name="fade" mode="out-in">
        <router-view v-if="pageReady" :class="{
          'col-lg-7 col-md-6 col-12': !onComparePage
          }" :key="$route.fullPath" />
      </transition>
      <transition name="fade" mode="out-in">
        <div v-if="!deviceMd "
          class="btn-toggle-availability
          d-flex justify-content-center w-100">
          <button class="btn btn-action"
            v-show="$route.name === 'FloorplanDetail'"
            @click="toggleMobileShowAvailability">
            {{ mobileAvailabilityToggleBtnLabel }}
          </button>
          <button v-show="$route.name === 'FloorplanList'
            || $route.name === 'FloorplanFavourites'"
            class="ml-2 btn btn-action"
            @click="showMobileFilters">
            Filter
          </button>
          <button v-show="$route.name === 'FloorplanDetail'"
            class="btn btn-action ml-2"
            @click="goToFloorplanList()">
            Floorplan List
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { create } from 'vue-modal-dialogs';
import MobileFloorplanFiltersDialog from '@/components/Dialogs/MobileFloorplanFiltersDialog';
import fstore from '@/analytics/firestore';
import FloorplanListActionsComponent from './FloorplanList/FloorplanListActions';
import AvailabilityComponent from './Availability/Availability';

const mobileFiltersDialog = create(MobileFloorplanFiltersDialog);

export default {
  name: 'floorplans-page',
  data() {
    return {
      unitViewedTimeout: null,
      firstLoad: true,
      firstLoadIOS: true
    };
  },
  computed: {
    ...mapState({
      hasScaleModel: state => state.project.hasScaleModel,
      mobileShowAvailability: state => state.ui.mobileShowAvailability,
      keyplanList: state => state.floorplans.availability.keyplanList,
      floorplanList: state => state.floorplans.list,
      pageReady: state => state.ui.pageReady,
      selectedUnitName: state => state.floorplans.selectedUnitName,
      isTouchscreen: state => state.project.isTouchscreen,
      filters: state => state.floorplans.filters,
    }),
    ...mapGetters({
      deviceMd: 'ui/deviceMd',
      getExposureByUnitName: 'floorplans/getExposureByUnitName'
    }),
    mobileAvailabilityToggleBtnLabel() {
      if (this.mobileShowAvailability) {
        if (this.$route.name === 'FloorplanList'
        || this.$route.name === 'FloorplanFavourites') {
          return 'Show Floorplans';
        }
        return 'Show Floorplan';
      }
      return 'Show Keyplans';
    },
    onComparePage() {
      return this.$route.name === 'FloorplanCompare';
    }
  },
  methods: {
    ...mapMutations({
      toggleMobileShowAvailability: 'ui/toggleMobileShowAvailability',
      setPageReady: 'ui/setPageReady',
      setFilters: 'floorplans/setFilters'
    }),
    ...mapActions({
      fetchFloorplans: 'floorplans/fetchFloorplans',
      fetchKeyplans: 'floorplans/availability/fetchKeyplans',
    }),
    showMobileFilters() {
      mobileFiltersDialog();
    },
    goToFloorplanList() {
      if (this.mobileShowAvailability) {
        this.toggleMobileShowAvailability();
      }
      this.$router.push('/');
    },
    checkReady() {
      if (!this.deviceMd || !this.hasScaleModel) {
        this.setPageReady(true);
      }
      if (!this.deviceMd && this.firstLoad) {
        setTimeout(() => {
          this.processSuitesQueryMobile();
          this.firstLoad = false;
        }, 1000);
      }
    },
    processSuitesQueryMobile() {
      console.log('process suites query mobile?');
      if (this.filters && this.filters.collectionList && this.$route.query.suites) {
        const val = this.$route.query.suites;
        if (this.filters.collectionList) {
          this.filters.collectionList.forEach((collection) => {
            if (collection.slug === val) {
              collection.active = true;
            }
          });
          this.setFilters(this.filters);
        }
        this.firstLoadIOS = false;
      }
    }
  },
  watch: {
    selectedUnitName(unitName) {
      if (unitName && !this.isTouchscreen) {
        // Track unit viewed
        if (this.unitViewedTimeout) {
          clearTimeout(this.unitViewedTimeout);
        }
        this.unitViewedTimeout = setTimeout(() => {
          let floor = unitName[unitName.length - 1];
          if (floor === '0') {
            floor = '10';
          }
          fstore.trackUnitViewed({
            floor,
            exposures: this.getExposureByUnitName(unitName)
          });
          this.unitViewedTimeout = null;
        }, 5000, this);
      }
    },
    $route(newRoute) {
      if (newRoute.name !== 'FloorplanDetail') {
        if (this.unitViewedTimeout) {
          clearTimeout(this.unitViewedTimeout);
        }
      }
    },
    filters: {
      immediate: true,
      handler() {
        if (this.filters && this.filters.collectionList && this.$route.query.suites && this.firstLoadIOS) {
          console.log('watcher caught filter update for IOS');
          setTimeout(() => {
            this.firstLoadIOS = false;
            this.processSuitesQueryMobile();
          }, 2000);
        }
      }
    }
    // pageReady: {
    //   immediate: true,
    //   handler() {
    //     this.processSuitesQueryMobile();
    //   }
    // }
  },
  mounted() {
    if (this.keyplanList.length === 0 || this.floorplanList.length === 0) {
      this.fetchFloorplans()
        .then(this.checkReady())
        // .then(this.processSuitesQueryMobile());
    } else {
      this.checkReady();
    }
    this.processSuitesQueryMobile();
  },
  beforeDestroy() {
    this.setPageReady(false);
    if (this.unitViewedTimeout) {
      clearTimeout(this.unitViewedTimeout);
    }
  },
  components: {
    'floorplan-list-actions': FloorplanListActionsComponent,
    availability: AvailabilityComponent
  }
};
</script>

<style lang="scss" scoped>
#floorplans-page {
  background-color: var(--background);
}

#availability {
  @media screen and (max-width: $breakpoint-medium) {
    position: absolute;
    top: 0;
    z-index: 100;
  }
}

.btn-toggle-availability {
  position: fixed;
  bottom: calc(15px + #{$app-bar-height-mobile});
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplansPage.vue